// Anchor flight
document.addEventListener('DOMContentLoaded', function () {
  const namespace = 'rnk-Hero_NavBar',
        navBar = document.querySelector(`.${namespace}`),
        speed = 500,
        movingFrequency = 15 // Affects performance !
  let links = navBar.querySelectorAll('a'),
      href

  const getScrollTopElement = element => {
    let top = 0

    while (element.offsetParent !== undefined && element.offsetParent !== null) {
      top += element.offsetTop + (element.clientTop !== null ? element.clientTop : 0)
      element = element.offsetParent
    }

    return top - (navBar ? navBar.getBoundingClientRect().height : 0)
  }

  const getScrollTopDocument = () => {
    return document.documentElement.scrollTop + document.body.scrollTop;
  }

  links.forEach(link => {
    const tabURL = new URL(link.href, location)

    if (location.pathname === tabURL.pathname && tabURL.hash !== '') {
      link.addEventListener('click', function () {
        const element = document.querySelector(tabURL.hash)

        if (element) {
          const hopCount = speed / movingFrequency
          const getScrollTopDocumentAtBegin = getScrollTopDocument()
          const gap = (getScrollTopElement(element) - getScrollTopDocumentAtBegin) / hopCount

          for (let i = 1; i <= hopCount; i++) {
            (function() {
              const hopTopPosition = gap * i

              setTimeout(function() {
                window.scrollTo(0, hopTopPosition + getScrollTopDocumentAtBegin)
              }, movingFrequency * i)
            })()
          }
        }

        return false
      })
    }
  })
})
